module.exports = __webpack_public_path__ + "img/createSosTest.8b9471ba.svg";